import { render, staticRenderFns } from "./StaffPageTableControl.vue?vue&type=template&id=4b3ba572&scoped=true&"
import script from "./StaffPageTableControl.vue?vue&type=script&lang=js&"
export * from "./StaffPageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ba572",
  null
  
)

export default component.exports